import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';

import { groupQueries } from './queries';

export function useGroupInfos() {
  const { group = '' } = useParams();

  const { data, isPending } = useQuery(groupQueries.infos(group));

  return {
    ...(data ?? { features: [], infos: null, feed: null }),
    isLoading: isPending,
  };
}
